module.exports = __webpack_public_path__ + "images/category_lp/pc/lp-pc-shop-image4_ee9c8f859569ae1ea8001de0b281a448.png";